import React from 'react';
import { Container} from "react-bootstrap";
import Authenticator from '../../../components/authentication/Authenticator/Authenticator';

const AuthenticatorPage = () => {
  return (
    <>
      <div style={{ background: "linear-gradient(-155deg, #00B2FF -35%, #1E0342 75%)", height: "100vh" }}>
        <Container>
          <main>
            <Authenticator />
          </main>
        </Container>
      </div>
    </>
  );
};

export default AuthenticatorPage;